/* Presentation only. Shopify owns consent state, events, persistence and Escape/close. */
(() => {
  if (window.alvornCookiePresentation) return;
  window.alvornCookiePresentation = true;
  const turkish = document.documentElement.lang.toLowerCase().startsWith('tr');

  function enhance() {
    const banner = document.getElementById('shopify-pc__banner');
    if (banner && !banner.dataset.alvornConsent) {
      const buttons = banner.querySelector('.shopify-pc__banner__btns');
      const accept = banner.querySelector('#shopify-pc__banner__btn-accept');
      const decline = banner.querySelector('#shopify-pc__banner__btn-decline');
      const manage = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
      if (buttons && accept && decline && manage) {
        banner.dataset.alvornConsent = 'ready';
        buttons.append(decline, accept, manage);
        const title = banner.querySelector('#shopify-pc__banner__body-title');
        if (turkish && title) title.textContent = 'Çerez tercihleri';
      }
    }

    // Shopify briefly retains a closing dialog during its exit transition.
    for (const dialog of document.querySelectorAll('.shopify-pc__prefs__dialog:not([data-alvorn-consent])')) {
      const actions = dialog.querySelector('.shopify-pc__prefs__header-actions');
      const save = dialog.querySelector('#shopify-pc__prefs__header-save');
      const decline = dialog.querySelector('#shopify-pc__prefs__header-decline');
      const accept = dialog.querySelector('#shopify-pc__prefs__header-accept');
      if (actions && save && decline && accept) {
        dialog.dataset.alvornConsent = 'ready';
        actions.append(save, decline, accept);
        dialog.append(actions);
        // This is a dialog heading, not a second site-wide banner landmark.
        const header = dialog.querySelector('header');
        if (header && !header.hasAttribute('role')) header.setAttribute('role', 'presentation');
        const label = dialog.querySelector('#shopify-pc__prefs__essential label');
        if (label && (turkish || document.documentElement.lang.startsWith('en'))) {
          const badge = document.createElement('small');
          badge.className = 'alvorn-cookie-always';
          badge.textContent = turkish ? 'Her zaman açık' : 'Always on';
          label.append(badge);
        }
        const close = dialog.querySelector('#shopify-pc__prefs__header-close');
        if (turkish && close) close.setAttribute('aria-label', 'Tercihleri kapat');
      }
    }
  }

  function navigatePreferences(event) {
    if (event.key !== 'Tab' || event.altKey || event.ctrlKey || event.metaKey) return;
    const dialog = Array.from(document.querySelectorAll('.shopify-pc__prefs__dialog[data-alvorn-consent]'))
      .find(element => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
    if (!dialog) return;
    const controls = Array.from(dialog.querySelectorAll('button, a[href], input, [tabindex]'))
      .filter(element => !element.disabled && element.tabIndex >= 0 && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
    if (!controls.length) return;
    const current = controls.indexOf(document.activeElement);
    const next = current < 0 ? (event.shiftKey ? controls.length - 1 : 0)
      : (current + (event.shiftKey ? -1 : 1) + controls.length) % controls.length;
    // Shopify caches its original last control (Analytics). After moving its footer,
    // handle Tab in current DOM order so Save/Reject/Accept remain keyboard reachable.
    event.preventDefault();
    event.stopImmediatePropagation();
    controls[next].focus();
  }

  function start() {
    enhance();
    document.addEventListener('keydown', navigatePreferences, true);
    new MutationObserver(enhance).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
